import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import Main from "./Main";
import TelemetryService from "./shared/services/TelemetryService";

const baseUrl =
  process.env.REACT_APP_ENV === "LOCAL"
    ? process.env.REACT_APP_CONSULTAI_URL_LOCAL
    : process.env.REACT_APP_ENV === "DEV"
    ? process.env.REACT_APP_CONSULTAI_URL_DEV
    : process.env.REACT_APP_ENV === "HML"
    ? process.env.REACT_APP_CONSULTAI_URL_HML
    : process.env.REACT_APP_CONSULTAI_URL_PROD;

// Configurar o serviço de telemetria
TelemetryService.configure({
  enabled: true,
  logLevel: "info",
  shouldConsoleLog: false,
  baseUrl: baseUrl, // Esta propriedade será adicionada no arquivo TelemetryService.ts
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <link
      rel="stylesheet"
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
    />
    <Main />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
